module.exports = __webpack_public_path__ + "./images/57ef3082aa7087e181a38f566f0b8db4.jpg";